<div class="overarching">
    <div *ngIf="isLoading" class="loading"><mat-spinner></mat-spinner></div>
    <canvas #chartCanvas [hidden]="isLoading"></canvas>
</div>